export default "__VITE_ASSET__Bai0Na_s__"